export default __webpack_public_path__ + "static/phase-basic-1-93b2f849ae13c5cff2a2b43eaf9c3adb.svg";